import {
    FETCH_DOC_BEGIN,
    FETCH_DOC_SUCCESS,
    FETCH_DOC_FAILURE,

    FETCH_MULTIPLEDOCS_BEGIN,
    FETCH_MULTIPLEDOCS_SUCCESS,
    FETCH_MULTIPLEDOCS_FAILURE,

    FETCH_DOCDETAILS_BEGIN,
    FETCH_DOCDETAILS_SUCCESS,
    FETCH_DOCDETAILS_FAILURE,
} from '../constants/assetDocuments';
import { 
    FETCH_ASSET_NOTESTAB_DETAILS_BEGIN,
    FETCH_ASSET_NOTESTAB_DETAILS_FAILURE, 
    FETCH_ASSET_NOTESTAB_DETAILS_SUCCESS,
    FETCH_ASSET_NOTE_DETAILS_BEGIN,
    FETCH_ASSET_NOTE_DETAILS_FAILURE,
    FETCH_ASSET_NOTE_DETAILS_SUCCESS
} from '../constants/assetNotes';

const initialState = {
    assetDocuments: [],
    mutipleDocuments: [],
    documentDetails: [],
    notesTab: [],
    isLoading: false,
    noteDetails: {},
    error: ""
}


//Asset Documents

export const getAssetDocumentReducer = (state = initialState, action) => {
    const { type, payload } = action;
    switch (type) {
        case FETCH_DOC_BEGIN: {
            return {
                ...state,
                isLoading: true,
                error: null,
            };
        }
        case FETCH_DOC_SUCCESS:
            return {
                ...state,
                isLoading: false,
                assetDocuments: payload.assetDocuments
            };
        case FETCH_DOC_FAILURE:
            return {
                ...state,
                error: payload.error,
                isLoading: true,
            };
        default:
            return state;
    }
}


//get Multiple Documents

export const getAssetMultipleDocumentReducer = (state = initialState, action) => {

    const { type, payload } = action;
    switch (type) {
        case FETCH_MULTIPLEDOCS_BEGIN: {
            return {
                ...state,
                isLoading: true,
                error: null,
            };
        }
        case FETCH_MULTIPLEDOCS_SUCCESS:
            return {
                ...state,
                isLoading: false,
                mutipleDocuments: payload.mutipleDocuments
            };
        case FETCH_MULTIPLEDOCS_FAILURE:
            return {
                ...state,
                error: payload.error,
                isLoading: true,
            };
        default:
            return state;
    }
}

//get  Document details
export const getDocumentdetailsReducer = (state = initialState, action) => {

    const { type, payload } = action;
    switch (type) {
        case FETCH_DOCDETAILS_BEGIN: {
            return {
                ...state,
                isLoading: true,
                error: null,
            };
        }
        case FETCH_DOCDETAILS_SUCCESS:
            return {
                ...state,
                isLoading: false,
                documentDetails: payload.documentDetails
            };
        case FETCH_DOCDETAILS_FAILURE:
            return {
                ...state,
                error: payload.error,
                isLoading: true,
            };
        default:
            return state;
    }
}
// Asset Details Notes Tab reducer 
export const getNoteTabDetailsReducer = (state = initialState, action) => {
    const { type, payload } = action;
    switch (type) {
        case FETCH_ASSET_NOTESTAB_DETAILS_BEGIN: {
            return {
                ...state,
                isLoading: true,
                error: null,
            };
        }
        case FETCH_ASSET_NOTESTAB_DETAILS_SUCCESS:
            return {
                ...state,
                isLoading: false,
                notesTab: payload.notesDetails
            };
        case FETCH_ASSET_NOTESTAB_DETAILS_FAILURE:
            return {
                ...state,
                error: payload.error,
                isLoading: true,
            };
        case FETCH_ASSET_NOTE_DETAILS_BEGIN: {
            return {
                ...state,
                isLoading: true,
                error: null,
            };
        }
        case FETCH_ASSET_NOTE_DETAILS_SUCCESS:
            return {
                ...state,
                isLoading: false,
                noteDetails: payload.notesDetail
            };
        case FETCH_ASSET_NOTE_DETAILS_FAILURE:
            return {
                ...state,
                error: payload.error,
                isLoading: true,
            };
        default:
            return state;
    }
}